import {StrictMode} from 'react';
import {render} from '@wordpress/element';

/**
 * Import the stylesheet for the plugin.
 */
import {RequestDemoForm} from "./components/RequestDemoForm";

// Render the App component into the DOM
render(
    <StrictMode>
        <RequestDemoForm/>
    </StrictMode>
    , document.getElementById('request-demo-page-form-root')
);